import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import PropTypes, { object } from 'prop-types';

import { CustomTooltip } from '../parts/parts';

import { textToDateM } from 'utils/common';
import { tick } from '../helpers/config';

const Chart = ({ data, config }) => {
  const formatter = value => (value !== 'auto' ? textToDateM(value) : '');

  return (
    <ResponsiveContainer width="100%" height={312}>
      <BarChart
        data={data}
        margin={{
          top: 4,
          right: 0,
          left: -20,
          bottom: 0
        }}
        barGap={8}
      >
        <CartesianGrid vertical={false} stroke="#dde6f2" />
        <XAxis
          dataKey="date"
          tick={tick}
          axisLine={false}
          tickLine={false}
          padding={{ left: 32, right: 32 }}
          tickCount={data.length}
          minTickGap={1}
          tickFormatter={formatter}
        />
        <YAxis
          tickCount={10}
          scale="linear"
          domain={[
            0,
            dataMax =>
              dataMax
                ? Math.ceil(dataMax * 1.1) +
                  (5 - (Math.ceil(dataMax * 1.1) % 5))
                : 100
          ]}
          tick={tick}
          axisLine={false}
          tickLine={false}
          minTickGap={1}
        />
        {data.length !== 0 && <Tooltip content={<CustomTooltip />} />}
        {config.map(item => {
          return (
            item.value && (
              <Bar
                key={item.name}
                fill={item.color}
                barSize={16}
                dataKey={item.name}
              />
            )
          );
        })}
      </BarChart>
    </ResponsiveContainer>
  );
};

Chart.propTypes = {
  data: PropTypes.arrayOf(object),
  config: PropTypes.arrayOf(object)
};

export default Chart;
